import S3 from 'aws-sdk/clients/s3';

const { Loader } = require('../utilities/cache/loader');

const loader = new Loader({
    name: `${process.env.CACHE_PREFIX || 'master'}|s3`,
    ttl: 60 * 60, // 60 min
    getKey: ({ Bucket, Key }) => `${Bucket}|${Key}`,
    functionToCache: async (usedBucket) => {
        try {
            const s3 = new S3();
            if (!usedBucket || !usedBucket.Bucket || !usedBucket.Key) {
                console.log('s3-data-service::::: Bucket/Key not specified');
                return { usedBucket };
            }

            console.log('s3-data-service::::: Start to get data from bucket');
            const data = await s3.getObject(usedBucket).promise();
            console.log('s3-data-service::::: Get data completed');
            const s3Data = JSON.parse(Buffer.from(data.Body, 'utf8'));
            return {
                s3Data,
                usedBucket,
                errMsg: 'success',
            };
        } catch (errMsg) {
            console.log('s3-data-service error:::::', errMsg, usedBucket);
            throw errMsg;
        }
    },
});

// eslint-disable-next-line consistent-return
async function getS3Data(primaryBucket, fallbackBucket) {
    // not exist then featch s3
    try {
        const result = await loader.load(primaryBucket);
        if (!fallbackBucket || result.errMsg === 'success') {
            return result;
        }
    } catch (errMsg) {
        return loader.load(fallbackBucket);
    }
}

export { getS3Data as default };
